import React from "react";
import { connect } from "react-redux";
import moment from "moment";

function homeTxt(props = {}) {
  const yrsOfExp = Math.floor(
    moment.duration(moment().diff(moment("2017-09-01", "YYYY-MM-DD"))).asYears()
  );
  return (
    <div>
      <h3>Hello there!</h3>
      <p align="justify">
        I am a Software Engineer with over {yrsOfExp} years of experience in
        full-stack development, I have delivered various projects through agile
        methodology and I enjoy building products that solve problems.
      </p>
      <p align="justify">
        I am constanly open to new challenges and opportunities. Get in touch
        with me at{" "}
        <a
          href="mailto:darrelltzj@gmail.com?subject=Ask%20Darrell%20About: &body=Hi Darrell,"
          target="_top"
          className="links"
        >
          darrelltzj@gmail.com
        </a>
        .
      </p>
    </div>
  );
}

function mapStateToProps(state = {}) {
  return {};
}

export default connect(mapStateToProps)(homeTxt);



// WEBPACK FOOTER //
// ./src/components/home/HomeTxt.js